import { render } from "./SingleChoice.vue?vue&type=template&id=07dc5f10"
import script from "./SingleChoice.vue?vue&type=script&lang=js"
export * from "./SingleChoice.vue?vue&type=script&lang=js"

import "./SingleChoice.vue?vue&type=style&index=0&id=07dc5f10&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__